import React from "react";
import { Link } from "react-router-dom";
import { localizedName } from "../utils/localizeProduct";
import { useLanguage } from "../i18n/LanguageContext";

const StepConfirmation = ({ order, address }) => {
  const { language, t } = useLanguage();

  const PAYMENT_LABELS = {
    CARD: t("payment.card"),
    PAYPAL: t("payment.paypal"),
    CASH_ON_DELIVERY: t("payment.cod"),
  };

  return (
    <div className="confirmation-popup">
      <h3>{t("confirmation.title")}</h3>
      <p>{t("confirmation.thanks", { name: address.name })}</p>

      <div className="receipt">
        <div className="receipt-row">
          <span>{t("confirmation.order").toUpperCase()}</span>
          <span>#{order.id}</span>
        </div>
        {order.items.map((item) => (
          <div className="receipt-row" key={item.id}>
            <span>
              {item.quantity}&times; {localizedName(item.product, language).toUpperCase()}
            </span>
            <span>${item.price.toFixed(2)}</span>
          </div>
        ))}
        <div className="receipt-row">
          <span>{t("confirmation.delivery").toUpperCase()}</span>
          <span>${Number(order.deliveryFee).toFixed(2)}</span>
        </div>
        <div className="receipt-row">
          <span>{t("confirmation.deliveringTo").toUpperCase()}</span>
          <span style={{ textAlign: "right" }}>{order.address}</span>
        </div>
        <div className="receipt-row">
          <span>{t("confirmation.payment").toUpperCase()}</span>
          <span>{PAYMENT_LABELS[order.paymentMethod] || order.paymentMethod}</span>
        </div>
        <div className="receipt-row">
          <span>{t("confirmation.total").toUpperCase()}</span>
          <span>${Number(order.total).toFixed(2)}</span>
        </div>
      </div>

      <Link to="/products" className="btn">
        {t("confirmation.keepShopping")}
      </Link>
    </div>
  );
};

export default StepConfirmation;
